import { createUseStyles } from 'react-jss'
import { useAppSelector } from "../redux/hooks"
import { useTranslation } from "react-i18next"
import { FileModel, FileType } from "../redux/types"
import InfoCard from "./InfoCard"
import { Colors } from "../constants/colors"
import File from "./File"

const GeneralFiles = () => {
    const styles = useStyles()
    const { t } = useTranslation(['files', 'common']);
    const files = useAppSelector(state => state.files.files)

    const fileFilter = (file: FileModel) => {
        return file.type === FileType.bankAccountFile;
    }
    
    // Early return if no files to display
    const generalFiles = files?.filter(fileFilter);
    if (!generalFiles || generalFiles.length === 0) {
        return null; // Don't render anything when no files exist
    }

    const renderFiles = () => {
        return (
            <InfoCard title={t('generalFiles', {ns: 'files'})} className={styles.infoCard}>
                {generalFiles.map((file, index) => (
                    <File file={file} key={`file_${index}`}/>
                ))}
            </InfoCard>
        )
    }

    return (
        <div className={styles.infoCardContainer}>
            {renderFiles()}
        </div>
    )
}

export default GeneralFiles

const useStyles = createUseStyles({
    container: {
        marginBottom: 40
    },
    infoCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        columnGap: 20
    },
    infoCard: {
        flex: 1,
        backgroundColor: Colors.grayBackgroundApp,
        minWidth: 450
    }
}) 